import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import {BrowserRouter} from "react-router-dom";
import './firebase'

 import './index.css';
import App from './App';

import {store} from './redux/store'
// import reportWebVitals from './reportWebVitals';

const rootElem = document.getElementById('root')

if (rootElem) {
  const root = ReactDOM.createRoot(rootElem);
root.render(
  <BrowserRouter>
  <Provider store={store}>
    <App />
    </Provider>
  </BrowserRouter>
);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
